// @flow

import React from "react";

import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";
import * as formatters from "../../utils/formatters";

import { AMOUNT, FINANCING_OWN_FOUNDS, FINANCING_DEMAND, FINANCING_SUPPORT } from "./formFields";

import { mapSupport } from "./mappers";
import { type FinancingSectionProps } from "../../types/details";

const FinancingShared = ({ initialValues, site }: FinancingSectionProps) => (
  <EditableForm initialValues={initialValues} isLocked>
    <FormRow separator>
      <EditableField
        fieldControlProps={{
          name: FINANCING_SUPPORT,
          caption: () => "Unterstützung durch einen Experten"
        }}
        displayValue={mapSupport(site === "customer")}
      />
    </FormRow>
    <FormRow>
      <EditableField
        fieldControlProps={{
          name: AMOUNT,
          caption: () => "Investitionskosten"
        }}
        displayValue={formatters.formatCurrency}
      />
      <EditableField
        fieldControlProps={{
          name: FINANCING_OWN_FOUNDS,
          caption: () => "Eigenmittel"
        }}
        displayValue={formatters.formatCurrency}
      />
      <EditableField
        fieldControlProps={{
          name: FINANCING_DEMAND,
          caption: () => "Finanzierungsbedarf"
        }}
        displayValue={formatters.formatCurrency}
      />
    </FormRow>
  </EditableForm>
);

export default FinancingShared;
